import React, { useEffect, useState } from "react";
import API2 from '../../api/indexv2';
import { handleError, orderStatus } from "../../components/common/utils";
import { GET_BUYER_ORDER } from "../../api/apiList";
import Loader from "../../components/common/loader";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import NoCart from "../../images/no-cart.svg"
import "./styles.scss"

const Order = () => {
  const [orderData, setOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    Orders();
  }, []);
  const Orders = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user")) || ""

    const body = {
      page: 1,
      limit: 50,
      userId: user?._id,
    };

    try {
      const response = await API2.post(GET_BUYER_ORDER, body);
      if (response?.data?.success) {
        setOrderData(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      handleError(error);
      setLoading(false);
      setOrderData([]);
    }
  };



  return (
    <>
      {loading ? (
        <div className="dotLoader">
          <Loader />
        </div>
      ) : (
        <>
          {orderData && orderData?.length > 0 ? (
            <>
              {orderData.map((order, index) => {
                const items = order?.quote?.breakup.filter(item => item["@ondc/org/title_type"] === "item");
                return (
                  <div key={index} onClick={() => {
                    navigate("/buyer-order-details", {
                      state: { orderId: order?._id },
                    });
                  }}
                  >
                    <a href="/buyer-order-details" className="order-card-link-kl">
                      <div className="drawer-body-content-kl">
                        <div className={order?.orderStatus === "Created" ? "  yellowOrder drawer-content-product-kl" : order?.orderStatus === "Cancelled" ? " RedOrder drawer-content-product-kl" : order?.orderStatus === "In-progress" ? "  BlueOrder drawer-content-product-kl" : order?.orderStatus === "Accepted" ? "  LightGreenOrder drawer-content-product-kl" : order?.orderStatus === "Completed" ? "  DarkGreenOrder drawer-content-product-kl" : "  drawer-content-product-kl"}>
                          {orderStatus(order?.orderStatus)}
                        </div>
                        <div>
                          <div className="drawer-content-title-kl" key={index}>
                            {items[0]?.title && <>{items[0]?.title}</>}
                          </div>
                          <div className="show-more-item-kl">
                            {items.length > 1 && ("... Show more items")}
                          </div>
                          <div className="drawer-content-text-kl">
                            Order Amount ₹ {order?.quote?.price?.value}
                            {order?.isOfferApplied && (
                              <> | Paid Amount ₹ {(parseFloat(order?.orderAmount) - parseFloat(order?.offerData?.discountedValue)).toFixed(2)}</>
                            )}
                          </div>
                          <span className="drawer-content-text-kl">{dayjs(order?.createdAt).format(
                            "MMM D, YYYY h:mm A"
                          )}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })}
            </>
          ) : (
            <div className="cart-empty-body">
              <div className="nothing-match">
                <div className="no-cart-img">
                  <img alt="Icon" src={NoCart} />
                </div>
                <h6 className="text-center">No Orders Found !!</h6>
              </div>
            </div>
          )}
        </>
      )}

    </>
  );
};
export default Order;

